import React, { useEffect, useState } from 'react'
import { Box } from '@material-ui/core'
import { useDebounce, useSwrApiGet } from '../../core'
import { CheckboxList, TextInput } from '../../eid-ui'

const contains = (text, searchTerm) => {
    return text.toLowerCase().indexOf(searchTerm.toLowerCase()) >= 0
}

const EidChecklist = ({
    url,
    dedupingInterval = 2000,
    debounceInterval = 300,
    shouldTriggerApiCall,
    onChange,
    value,
    queryParams,
    supportsServerSideSearch = true,
    searchable = false,
    searchPlaceholder,
    fallbackMessage,
    transformResponse,
}) => {
    const queryStringParts = []
    const [searchKey, setSearchKey] = useState('')
    const debouncedValue = useDebounce(searchKey, debounceInterval)

    Object.keys(queryParams).forEach((key) => {
        if (queryParams[key] !== undefined)
            queryStringParts.push(`${key}=${queryParams[key]}`)
    })

    if (supportsServerSideSearch && debouncedValue) {
        queryStringParts.push(`searchTerm=${debouncedValue}`)
    }

    const queryString = queryStringParts.join('&')
    const urlWithQs = queryString ? `${url}?${queryString}` : url

    const [filteredData, setFilteredData] = useState([])

    const { data } = useSwrApiGet(
        shouldTriggerApiCall ? urlWithQs : undefined,
        {
            dedupingInterval,
        },
    )

    useEffect(() => {
        if (data) {
            let dataToSet = data.data
            if (!supportsServerSideSearch && searchKey !== '') {
                dataToSet = dataToSet.filter(
                    (item) =>
                        contains(item.friendlyName, searchKey) ||
                        contains(item.name, searchKey),
                )
            }
            if (transformResponse) {
                setFilteredData(transformResponse(dataToSet))
            } else {
                setFilteredData(dataToSet)
            }
        }
    }, [data, searchKey])

    return (
        <>
            {searchable && (
                <Box marginBottom="15px">
                    <TextInput
                        placeholder={searchPlaceholder}
                        value={searchKey}
                        handleChange={(e) => setSearchKey(e.target.value)}
                    />
                </Box>
            )}
            <Box paddingX="10px">
                <CheckboxList
                    dataList={filteredData}
                    fontColor="#000000"
                    itemContainerHeight="20px"
                    handleToggle={onChange}
                    checked={value}
                    loading={!data}
                    highlightText={searchKey}
                    fallbackMessage={fallbackMessage}
                />
            </Box>
        </>
    )
}

export default EidChecklist
